// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__mxBsv","title":"ClientCherryInfo_title__DtQkR","itemText":"ClientCherryInfo_itemText__2isuh"};